import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9fbpd42gp: FaireProductEntity = {
  token: "p_n9fbpd42gp",
  type: "product",
  name: "Poke Root Liquid Extract – Lymphatic Drainage Support",
  brandToken: "b_j95bbpz4b7",
  brandName: "HEBS lab",
  imageUrl:
    "https://cdn.faire.com/fastly/6896f73e90311525c5149852dd37467daadf471bebb804ca08aa74267a400798.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/993a594f412208e6d8d4e5cfc080fd8ac11efd0b3dd4b52ace448e53d50ceb47.jpeg",
    "https://cdn.faire.com/fastly/1476dc37eb85f2080bfd7bc79b01854a48c67faca8b0451104685f655883f15f.jpeg",
    "https://cdn.faire.com/fastly/770221f3142f5ee846815bed2d41506378886b22b4f22e2f5957c93fa2412a3a.jpeg",
  ],
  priceDollars: 9.48,
  description:
    "Poke Root Liquid Extract is a high-demand herbal tincture targeting one of the fastest-growing wellness categories — lymphatic health and detox support. As consumers increasingly seek natural solutions for immune and lymphatic function, Poke Root has become a sought-after product in apothecary and holistic health retail.\nWhy stock this product:\nLymphatic drainage is a trending topic in natural health — driven by growing consumer interest in detox, immune resilience, and holistic body care. Poke Root is a staple herb in traditional herbalism with strong repeat purchase potential.\nProduct highlights:\n ∙ Extra Strength formula — high perceived value\n ∙ Alcohol-free liquid extract with fast absorption\n ∙ Clean label — no artificial additives or fillers\n ∙ Amber glass bottle with dropper — shelf-ready\n ∙ Made in USA \nBest fit for: apothecaries, natural health stores, holistic wellness boutiques, herbal remedy retailers.",
  tags: [],
  msrpDollars: 18.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:24.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
